const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the notifications edit component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {UserNotifications} UserNotifications the resource defined to manage UserNotifications
 */
app.directive('userNotificationsEdit', ['Application', 'Authorization', 'UserNotifications', '$translate', function (Application, Authorization, UserNotifications, $translate) {
    return {
      restrict: 'E',
      template: require('../../templates/directives/user-notifications-edit.html'),
      controller: function () {
        var self = this;
        self.getError = Application.notifications.getError;
        self.getSuccess = Application.notifications.getSuccess;
        self.user = Authorization.getAuthToken().user;
        var originalNotifications;
        self.disableSubmit = true;

        self.update = function() {
          self.buttonLoading = true;
          UserNotifications.update({subresource: self.user._id}, {
            notifications: self.notifications
          }, function(data) {
            originalNotifications = JSON.parse(JSON.stringify(data.notifications));
            self.disableSubmit = true;
            self.buttonLoading = false;
            Application.messaging.addMessage({type: 'success', text: self.translations['modules.notifications.haveBeenUpdated'], duration: 5});
          }, function(error) {
            self.disableSubmit = true;
            self.buttonLoading = false;
            Application.messaging.addMessage({type: 'error', text: self.translations['modules.notifications.canNotUpdateNotifications'], duration: 5});
          });
        };

        self.checkChanges = function() {
          var temp = true;
          var items = ['app', 'email'];
          angular.forEach(items, function(item) {
            if (originalNotifications[item] !== self.notifications[item]) {
              temp = false;
            }
          });
          self.disableSubmit = temp;
        };

        self.initialize = function () {
          self.loading = true;
          UserNotifications.get({
            subresource: self.user._id + ''
          }, function (data) {
            // This is a hack for checking changes - works for non function values.
            originalNotifications = JSON.parse(JSON.stringify(data.notifications));
            self.notifications = data.notifications;
            self.loading = false;
          }, function (error) {
            console.log('Error occured getting Notifications ', error);
          });

        };

        $translate(['modules.notifications.haveBeenUpdated', 'modules.notifications.canNotUpdateNotifications']).then(function(data){
          self.translations = data;
          self.initialize();
        });

      },
      controllerAs: 'notifications'
    };
  }]);



